import { z } from "zod";

const DataSchema = z.object({
    id: z.string(),
    name: z.string(),
    email: z.string(),
    email_verified_at: z.nullable(z.string()),
    created_at: z.string(),
    updated_at: z.string(),
    channex_user_api_key: z.nullable(z.string()),
    username: z.nullable(z.string()),
    phone: z.nullable(z.string())
});

export const UsersResponse = z.object({
    code: z.number(),
    success: z.boolean(),
    message: z.string(),
    data: z.array(DataSchema),
});